<template>
  <div class="text-center">
    <aha-icon name="no-presentation" maintain-color />
    <div v-if="!shared" class="text-base font-bold">
      No presentations here yet
    </div>
    <div v-else class="text-base font-bold">
      No shared presentations here yet
    </div>
    <div class="mt-2 text-base-80">
      <p v-if="shared">
        When someone shares their presentation with you, it will show up here.
      </p>
      <p v-else>
        You can create and import a presentation here.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shared: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
